import React, { useState } from "react";
import { images } from "../utils/constants";

function Gallery() {
  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  return (
    <div className="grid-root">
      <h2>A Love Story in Pictures 📷</h2>
      <div className="grid">
        {images.map((image, index) => (
          <img key={index} src={image} alt={`image-${index}`} onClick={() => handleImageClick(image)} style={{ cursor: "pointer" }} />
        ))}
      </div>

      {selectedImage && (
        <div className="large-image-overlay" onClick={closeImage}>
          <div className="large-image-container">
            <img src={selectedImage} alt="large view" />
            <a
              href={selectedImage}
              download="image.jpg"
              style={{
                display: "inline-block",
                marginTop: "10px",
                padding: "10px",
                backgroundColor: "#4CAF50",
                color: "white",
                textDecoration: "none",
                borderRadius: "5px",
              }}
            >
              Download Image
            </a>
          </div>
        </div>
      )}
    </div>
  );
}

export default Gallery;
